module.exports = __webpack_public_path__ + "images/vkb_yes.svg?f3dde790e8c51a299a089441e5bfb9ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/vkb_yes.svg
// module id = midJ
// module chunks = 0